"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributePath = void 0;
var tslib_1 = require("tslib");
var ATTRIBUTE_PATH_TAG = 'AmazonDynamoDbAttributePath';
var EXPECTED_TAG = "[object ".concat(ATTRIBUTE_PATH_TAG, "]");
/**
 * The path to an attribute of a DynamoDB item or to a property
 * or member thereof. Supports map property access (`map.property`)
 * and list member access (`list[1]`).
 *
 * Control characters that are part of the property identifier may be
 * used when escaped with a backslash (`\`) character.
 */
var AttributePath = /** @class */ (function () {
    function AttributePath(path) {
        this[_a] = ATTRIBUTE_PATH_TAG;
        if (typeof path === 'string') {
            this.elements = parsePath(path);
        }
        else {
            this.elements = tslib_1.__spreadArray([], tslib_1.__read(path), false);
        }
    }
    /**
     * Determine if the provided value is an AttributePath object.
     * Compatible with AttributePath objects generated in other iframes
     * or Node VMs.
     */
    AttributePath.isAttributePath = function (arg) {
        return arg instanceof AttributePath
            || Object.prototype.toString.call(arg) === EXPECTED_TAG;
    };
    return AttributePath;
}());
exports.AttributePath = AttributePath;
_a = Symbol.toStringTag;
var LEFT_BRACKET = '[';
var RIGHT_BRACKET = ']';
var PATH_DELIMITER = '.';
var ESCAPE_CHARACTER = '\\';
function parsePath(path) {
    var elements = [];
    var state = 1001 /* ParseState.identifier */;
    var collected = '';
    for (var iter = path[Symbol.iterator](), curr = iter.next(), peek = iter.next(); curr.done === false; curr = peek, peek = iter.next()) {
        if (state === 1001 /* ParseState.identifier */) {
            switch (curr.value) {
                case LEFT_BRACKET:
                    state = 1002 /* ParseState.listIndex */;
                // fallthrough
                case PATH_DELIMITER:
                    if (collected === '') {
                        throw new Error("Invalid control character encountered in path: ".concat(path));
                    }
                    elements.push({ type: 'AttributeName', name: collected });
                    collected = '';
                    break;
                case ESCAPE_CHARACTER:
                    if (peek.value === PATH_DELIMITER ||
                        peek.value === LEFT_BRACKET ||
                        peek.value === ESCAPE_CHARACTER) {
                        curr = peek;
                        peek = iter.next();
                    }
                // fallthrough
                default:
                    collected += curr.value;
            }
        }
        else if (state === 1002 /* ParseState.listIndex */) {
            switch (curr.value) {
                case RIGHT_BRACKET:
                    var intVal = parseInt(collected);
                    if (!isFinite(intVal)) {
                        throw new Error("Invalid array index (".concat(collected, ") encountered in path: ").concat(path));
                    }
                    elements.push({ type: 'ListIndex', index: intVal });
                    collected = '';
                    state = 1000 /* ParseState.controlCharacter */;
                    break;
                case '0':
                case '1':
                case '2':
                case '3':
                case '4':
                case '5':
                case '6':
                case '7':
                case '8':
                case '9':
                    collected += curr.value;
                    break;
                default:
                    throw new Error("Invalid array index character (".concat(curr.value, ") encountered in path: ").concat(path));
            }
        }
        else {
            switch (curr.value) {
                case LEFT_BRACKET:
                    state = 1002 /* ParseState.listIndex */;
                    break;
                case PATH_DELIMITER:
                    state = 1001 /* ParseState.identifier */;
                    break;
                default:
                    throw new Error("Bare identifier encountered between list index accesses in path: ".concat(path));
            }
        }
    }
    if (collected.length > 0) {
        elements.push({ type: 'AttributeName', name: collected });
    }
    return elements;
}
